module.exports = __webpack_public_path__ + "static/media/CloseForm.897fed56.svg";